const acceptanceLevels = {
  en: {
    regionFallback: "rest of the world",
    tooltip: {
      H: "Many locations accept your card here",
      G: "Growing number of locations accept your card here",
      J: "Limited locations accept your card here",
      "NO COVERAGE": "No locations accept your card here",
    },
    legend: {
      headline: "Card Acceptance",
    },
    modal: {
      headline: "Card Acceptance",
    },
    levels: {
      H: {
        title: "Accepted",
        desc: "Your card is accepted in locations within the country. Select the country to see more details.",
      },
      "NO COVERAGE": {
        title: "Not Accepted",
        desc: "Your card is not accepted in the country yet.",
      },
    },
    headlinesAlt: {
      H: "Your card is part of global network, so you can travel with confidence.",
      G: "Your card is part of global network, so you can travel with confidence.",
      J: "Your card is part of a global network that is expanding all the time.",
      "NO COVERAGE":
        "Your card is not accepted here—but we are working on it. Because your card is part of a global network, you can use your card throughout {region}. We are continuing to expand so you can use your card more and more places globally.",
    },
  },
  es: {
    regionFallback: "resto del mundo",
    tooltip: {
      H: "Muchas ubicaciones aceptan su tarjeta aquí",
      G: "Un número creciente de ubicaciones aceptan su tarjeta aquí",
      J: "Un número limitado de ubicaciones aceptan su tarjeta aquí",
      "NO COVERAGE": "Ninguna ubicación acepta su tarjeta aquí",
    },
    legend: {
      headline: "Aceptación global",
    },
    modal: {
      headline: "Aceptación global",
    },
    levels: {
      H: {
        title: "Muchas ubicaciones",
        desc: "Muchas ubicaciones aceptan su tarjeta, especialmente en destinos de viaje populares",
      },
      G: {
        title: "Ubicaciones en Expansión",
        desc: "Un número creciente de ubicaciones aceptan su tarjeta, especialmente restaurantes, hoteles y comercios.",
      },
      J: {
        title: "Ubicaciones Limitadas",
        desc: "Un número limitado de ubicaciones aceptan su tarjeta.",
      },
      "NO COVERAGE": {
        title: "Aún no hay ubicaciones",
        desc: "Su tarjeta aún no es aceptada aquí.",
      },
    },
    headlinesAlt: {
      H: "Tu tarjeta es parte de la red global, por lo que puedes viajar con confianza.",
      G: "Tu tarjeta es parte de la red global, por lo que puedes viajar con confianza.",
      J: "Tu tarjeta es parte de una red global que está en constante expansión.",
      "NO COVERAGE":
        "Tu tarjeta no es aceptada aquí, pero estamos trabajando en ello. Como tu tarjeta es parte de una red global, puedes usar tu tarjeta en muchos lugares de {region}. Estamos continuando con la expansión para que puedas usar tu tarjeta en más y más lugares globalmente.",
    },
  },
};

export default acceptanceLevels;
